import React from "react";
import { Route } from "react-router-dom";
import AllowanceDetailRoutes from "./allowance-detail";
import AllowanceRoutes from "./allowance";
import AttendanceRoutes from "./attendance";
import CategoryEmployeeRoutes from "./category-employee";
import DailyAttendanceRoutes from "./daily-attendance";
import DivisionRoutes from "./division";
import EmployeeRoutes from "./employee";
import HolidayRoutes from "./holiday";
import PositionRoutes from "./position";
import RecapAttendanceRoutes from "./recap-attendance";
import SalaryClassRoutes from "./salary-class";
import SalaryCutsRoutes from "./salary-cuts";
import SalaryCutsDetailRoutes from "./salary-cuts-detail";
import SalaryTypeRoutes from "./salary-type";

export default function HrRoutes( props ) {
    return (
    <Route path="/hr">
        {AllowanceDetailRoutes(props)}
        {AllowanceRoutes(props)}
        {AttendanceRoutes(props)}
        {CategoryEmployeeRoutes(props)}
        {DailyAttendanceRoutes(props)}
        {DivisionRoutes(props)}
        {EmployeeRoutes(props)}
        {HolidayRoutes(props)}
        {PositionRoutes(props)}
        {RecapAttendanceRoutes(props)}
        {SalaryClassRoutes(props)}
        {SalaryCutsRoutes(props)}
        {SalaryCutsDetailRoutes(props)}
        {SalaryTypeRoutes(props)}
    </Route>
    )
}